// import "@fortawesome/fontawesome-free/css/all.css";
// import "material-design-icons-iconfont/dist/material-design-icons.css";
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  rtl: true,
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
  // icons : {
  //   iconfont : 'md' || 'fa'
  // }
});
